module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "css.worker.e0689cff24f7ea6e80b8.js");
}
